import {observer} from "mobx-react-lite";
import {Link} from "react-router-dom";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import {ConfirmPurchaseResponse} from "../../../entity/resource/confirm-purchase-response";
import {Box, Button, Card, CardContent, Divider, Typography} from "@mui/material";
import React, {useState, useEffect} from "react";
import {useService} from "../../../infrastructure/service/service";
import LoadingComponent from "../components/widget/LoadingComponent";

import '../../../assets/css/style.css';
import '../../../assets/css/pages/subscription-callback.css';

const BillingCallback = (): JSX.Element => {
    const {userService, subscriptionService} = useService();

    const [purchaseResult, setPurchaseResult] = useState<ConfirmPurchaseResponse>();
    const [isLoading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const init = async (): Promise<void> => {
            setLoading(true);

            const user = await userService.getCurrentUser();
            const urlParams = new URLSearchParams(window.location.search);
            const sessionIdParams = urlParams.get('session_id');

            if (sessionIdParams && user) {
                const response = await subscriptionService.confirmPurchase(user.organizationID, { sessionID: sessionIdParams });
                if (response)
                    setPurchaseResult(response);
            }

            setLoading(false);
        }
        init();
    }, []);

    if (isLoading)
        return <LoadingComponent title={'Processing your purchase...'}/>

    return (
        <>
            <Box className={'body-box subscription-callback-container'}>
                <Card elevation={0} className={'chart-card subscription-callback-card'}>
                    <CardContent className={'subscription-callback-container description'}>
                        <Box className={'subscription-callback-icon-container success'}>
                            <CheckCircleRoundedIcon className={'subscription-callback-icon success'}/>
                        </Box>
                        <Typography id={'text-billing-status'} className={'subscription-callback-header'}>
                            Token Purchase Successful!
                        </Typography>
                        <Typography id={'text-billing-description'} className={'subscription-callback-description'}>
                            {
                                `Your token purchase has been processed successfully. ${purchaseResult?.tokensAdded} tokens have been added to your account.`
                            }
                        </Typography>
                        <Box>
                            <Typography id={'text-billing-balance'} className={'subscription-callback-footer'}>
                                Your new token balance is: <strong>{purchaseResult?.balance} tokens</strong>
                            </Typography>
                        </Box>
                        <Divider className={'subscription-callback-divider'} />
                        <Button
                            id={'btn-billing-callback'}
                            className={'zitles-button submit'}
                            component={Link}
                            to={'/marketplace'}>
                            Back to Marketplace
                        </Button>
                    </CardContent>
                </Card>
            </Box>
        </>
    );
}

export default observer(BillingCallback);
